import styled from 'styled-components'
import pxToRem from '../../utils/pxToRem'
import { deviceMax, deviceMin } from '../../theme/breakpoints'
import Heading from '../Heading/Heading'
import Slider from 'react-slick'
import SliderArrow from '../../images/icons/slider-left.svg'
import { CarouselVariantEnum } from './Carousel'
import IconButton from '../IconButton/IconButton'

export const StyledWrapper = styled.div`
  border-radius: ${pxToRem(5)};
  margin-bottom: ${pxToRem(20)};
  width: 100%;
  height: fit-content;
  padding: ${pxToRem(20)};
  background-color: ${({theme}) => theme.colors.unique.white};
  ${({$orientation}) =>
          $orientation === CarouselVariantEnum.horizontal ?
                  `background-color: initial;` : `max-width: ${pxToRem(386)};
`};
  @media ${deviceMax.mobileL} {
    border-radius: 0;
  }
  @media ${deviceMax.tablet} {
    padding: ${pxToRem(20)};
  }
  @media ${deviceMin.tablet} {
    div {
      ${({$orientation}) =>
              $orientation === CarouselVariantEnum.horizontal && `display: flex ;`}
    }
  }
`

export const StyledCarrouselHeader = styled.div`
  align-items: center;
  flex-wrap: wrap;
  justify-content: space-between;
  display: flex;
  width: 100%;
  margin-bottom: ${pxToRem(10)};
  gap: 10px;
`
export const StyledTitle = styled(Heading)`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-weight: ${({theme}) => theme.fonts.weight.medium};
`
export const StyledSlider = styled(Slider)`
  width: 100%;

  ${({$orientation, $isMobile}) =>
          $orientation === CarouselVariantEnum.horizontal &&
          !$isMobile &&
          `
    margin-right: ${pxToRem(-20)};
    `}
  .slick-list {
    width: 100%;
  }

  .slick-track {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: flex-start;

    .slick-slide div {
      gap: ${pxToRem(10)};
      width: 100%;
    }

    .slick-slide > div:not(:first-child):not(:empty) {
      margin-top: ${pxToRem(10)};
    }
  }
`

export const StyledCarrouselControls = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin-left: auto;

  @media ${deviceMax.tablet} {
    gap: 10px;
  }
`
export const SliderArrowLeft = styled(SliderArrow)``

export const SliderArrowRight = styled(SliderArrow)`
  transform: rotate(180deg);
`

export const StyledCarourelDots = styled.div`
  display: flex;
  flex-wrap: wrap;
`

export const StyledCarouselArrows = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 10px;

  @media ${deviceMax.tablet} {
    margin-bottom: 0;
  }
  
`

export const StyledIconButton = styled(IconButton)`
  margin-bottom: 10px;

  @media ${deviceMax.tablet} {
    margin-bottom: 0; 
  }
`